import styled from 'styled-components';

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  flex: 1;
  min-height: 0;
`;

export const ScrollableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-height: 0;
`;

export const ScrollableContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 8px;
`;

export const NavigationBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 28px;
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MetadataSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
`;

export const MetadataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 150px;
`;

export const MetadataLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const MetadataValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TopicSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TopicSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TopicItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const TopicContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const SlideoutActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: auto;
`;

